/**
 * Created by kfaulhaber on 26/07/2017.
 *
 * Status enum for setting the status of a custom Response
 *
 */

export enum Status {
  Neutral = 0,
  Rejected,
  Resolved,
}
